import { render } from "./AskDoubtTeacher.vue?vue&type=template&id=66dd42b0&scoped=true"
import script from "./AskDoubtTeacher.vue?vue&type=script&lang=js"
export * from "./AskDoubtTeacher.vue?vue&type=script&lang=js"

import "./AskDoubtTeacher.vue?vue&type=style&index=0&id=66dd42b0&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dd42b0"]])

export default __exports__